import React, { Component } from 'react';
import { GridColumnMenuFilter } from '@progress/kendo-react-grid';

class ColumnMenu extends Component {
    render() {
        return (
            <div>
                <GridColumnMenuFilter {...this.props} expanded={true}/>
            </div>
        );
    }
}

export default ColumnMenu;